import UpdateUs from './UpdateUs';

export default UpdateUs;
